import { createBrowserRouter, Navigate, Outlet } from 'react-router';
import { Shell } from '@/widgets/app-shell';
import { HomePage } from '@/pages/home';
import { StickerPage } from '@/pages/sticker';
import { LetterPage } from '@/pages/letter';
import { PriceStickersPage } from '@/pages/price-stickers';

// Every page sits in the Toolkit frame (menu + page).
function Layout() {
  return <Shell><Outlet /></Shell>;
}

// The addresses are the old pages' (/, /index.html, /type1-sticker-4x6.html, /type2-letter-sheets.html), so bookmarks keep
// working; /price-stickers is new. A label maker starts fresh each time it is opened, as the separate pages did.
export const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: '/', element: <HomePage /> },
      { path: '/index.html', element: <HomePage /> },
      { path: '/type1-sticker-4x6.html', element: <StickerPage /> },
      { path: '/type2-letter-sheets.html', element: <LetterPage /> },
      { path: '/price-stickers', element: <PriceStickersPage /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
